//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { scrolingGallery, checkAuthor } from '~/utils/utils';
export default {
  props: {
    authorId: {
      type: [String, Number],
      default: ''
    },
    masterpieceId: {
      type: [String, Number],
      default: ''
    }
  },
  data() {
    return {
      x: 0
    }
  },
  computed: {
    isEn () {
      return this.$i18n.locale === 'en'
    },
    eventsListeners() {
      return {
        ...this.$listeners,
        ...scrolingGallery(this, 'masterpieceFootKarusel')
      }
    },
    currentMasterpieces() {
      const result = []
      const items = this.masterpiecesByAuthor.data.data.items
      if (items) {
        items.forEach(element => {
          if (Number(element.id) === Number(this.masterpieceId) || !element.picture){
            return
          }
          result.push(element)
        });
      }
      return result
    }
  },
  methods: {
    checkVerification(item, author) {
      return checkAuthor(item, author)
    },
    handleLink(e) {
      if (!this.movingActive) {
        e.preventDefault()
        e.stopPropagation()
      }
    }
  },
  chimera: {
    masterpiecesByAuthor () {
      return {
        url: `/api/v1/gallery/get/`,
        key: `masterpieces-by-author-${this.authorId}`,
        auto: true,
        params: {
          pageNum: 1,
          pageSize: 10,
          "filter[author]": this.authorId,
          lang: this.$i18n.locale || 'ru'
        }
      }
    }
  }
}
